import React, { useEffect, useContext } from 'react';

import 'styles/Default.scss';

import { useSelector, useDispatch } from 'react-redux';
import { Main, Landing } from 'pages';

import { SyncContext } from 'contexts/sync';

import db from 'database';

window.db = db;

function App() {
  const dispatch = useDispatch();
  const user = useSelector(state => state.user);
  const isAuthenticated = user.auth.token;

  const {
    syncProcess,
    runSyncProcess,
    stopSyncProcess,
    automaticSync,
  } = useContext(SyncContext);

  useEffect(() => {
    if (isAuthenticated && !syncProcess) {
      runSyncProcess();
    } else if (!isAuthenticated) {
      stopSyncProcess();
    }
  }, [
    dispatch,
    isAuthenticated,
    syncProcess,
    runSyncProcess,
    stopSyncProcess,
    automaticSync,
  ]);

  return <>{isAuthenticated ? <Main /> : <Landing />}</>;
}

export default App;
